import Button from '#components/Button/Button.js';
import { Icon } from '#components/Icon/Icon.js';
import { Modal } from '#components/Modal/Modal.js';
import Typography from '#components/Typography/Typography.js';
import styles from './DiscardNoteModal.module.css';

type Props = {
  isOpen: boolean;
  onClose: VoidFunction;
  onCancel: VoidFunction;
  onDiscard: VoidFunction;
};

export default function DiscardNoteModal({
  isOpen,
  onClose,
  onCancel,
  onDiscard,
}: Props) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} showFloatingX>
      <div className={styles.container}>
        <Icon name='alertCircleFilled' className={styles.icon} size={64} />
        <div className={styles.textsContainer}>
          <Typography variant='heading-l'>Discard edits?</Typography>
          <Typography variant='body-s'>
            You will lose all saved changes you&apos;ve made if you revert to
            the current published version.
          </Typography>
        </div>
        <div className={styles.buttonsContainer}>
          <Button
            label='Do not discard'
            variant='outline'
            color='purple'
            width='full'
            onClick={onCancel}
          />
          <Button
            label='Discard edits'
            variant='solid'
            color='purple'
            width='full'
            onClick={onDiscard}
          />
        </div>
      </div>
    </Modal>
  );
}
